import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";

const StaticPage = () => {
  const { type } = useParams();
  const [pageContent, setPageContent] = useState("");
  const [pageHeading, setPageHeading] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await getApi({
        apiUrl: API_URLS.GET_STATIC_PAGES(type),
      });
      if (response.success) {
        const content = response.data.content;
        setPageContent(content.pageContent);
        setPageHeading(content.pageHeading);
      } else {
        toast.error("Page content not found");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load page content");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [type]);
  if (loading)
    return <div className="p-4 text-center bg-white">Loading...</div>;
  return (
    <div className="bg-white">
      {pageContent ? (
        <div className="p-6 max-w-4xl mx-auto  text-center pt-20 ">
          <h1 className="text-4xl font-light mb-4 text-blue-800">
            {pageHeading}
          </h1>
          {/* <div dangerouslySetInnerHTML={{ __html: pageContent }} /> */}

          <div> {pageContent}</div>
        </div>
      ) : (
        <div className="p-4 pt-32 ">
          <p className=" text-center text-red-500  text-xl ">Page Not Found</p>
        </div>
      )}
    </div>
  );
};

export default StaticPage;
